/**
 * Kleine helper om conversies naar Google Analytics te sturen: gebeld,
 * geappt of een offerte aangevraagd. Werkt alleen in de browser en doet
 * niets wanneer de analytics-tag (nog) niet geladen is.
 */
type Gtag = (command: string, eventName: string, params?: Record<string, unknown>) => void;

export type ConversionEvent = "telefoon_klik" | "whatsapp_klik" | "email_klik" | "offerte_verzonden";

export function trackConversion(event: ConversionEvent, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: Gtag }).gtag;
  if (typeof gtag !== "function") return;
  gtag("event", event, {
    ...params,
    page_path: window.location.pathname,
  });
}
